export default __webpack_public_path__ + "static/kg-sketch-b9a1971bba3c9bc8a73bf4fe3123aa7e.jpg";